import { useAbStore } from '@/store/useAbStore';

/**
 * 首屏的AB接口调用太多了，需要收拢一下，如：商详首屏编写这个hooks当天有6个AB
 * @deprecated 将ab信息放到单例的store中了，使用 useAbStore 代替，大家可以使用selector来减少ab导致的render
 */
export function useFirstScreenAB<
    T extends {
        // ab是否加载中
        isAbLoading?: boolean;
        // ab内容的key value对
        [key: string]: any;
    }
>() {
    const abState = useAbStore();
    return abState as unknown as T;
}
